import React, { useEffect, useState } from 'react';
import DataTableLayout from '../../../../utility/table/DataTableLayout.jsx';
import ConfirmModal from './../../../../utility/modals/ConfirmModal.jsx';
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";
import { MarketPlaceAccountsTableData } from '../../Common/Datatable';
import useMarketplaceAccount from './useMarketplaceAccounts';
import useMarketPlaceModal from "../MarketPlaceModal/useMarketPlaceModal";
import Loading from '../MarketPlaceModal/Loading/Loading';
import DashboardReady from '../DashboardReady/DashboardReady'
import { useTranslation } from 'react-i18next';
import { useRazorpay } from '../../../../context/RazorpayContext.js';
import AddonPreviewModal from '../Razorpay/AddonPreviewModal.jsx';
import RazorpayModal from '../Razorpay/RazorpayModal.jsx';


const MarketPlaceAccounts = () => {
  const {
    modalOpen,
    selectedBadge,
    handleBadgeClick,
    handleConfirm,
    handleCancel,
    modalOpenLoading,
    setModalOpenLoding
  } = useMarketplaceAccount();
  const { handleAddOnInvoicePreview, addonInvoicePreviewData, razorpayModalData } = useRazorpay();
  const { loading, handleConnect, marketplaceData, getMarketplaces } = useMarketPlaceModal();
  const { t } = useTranslation();
  useEffect(() => {
    getMarketplaces()
  }, []);

  const afterPaymentSuccessNavigationUrl = '/billing-section';
  const { tableId, ajaxUrl, columns, tableIdParams } = MarketPlaceAccountsTableData;
  const [traceBtnClick, setTraceBtnClick] = useState({
    isLoading: false,
    btnClickPackageId: null
  })

  const handlePayAgain = async (e, marketplaceAccountId) => {
    e.preventDefault();
    try {
      setTraceBtnClick((prev) => ({
        ...prev,
        isLoading: true,
        btnClickPackageId: marketplaceAccountId
      }))
      await handleAddOnInvoicePreview(null, marketplaceAccountId)
    }
    finally {
      setTraceBtnClick((prev) => ({
        ...prev,
        isLoading: false,
        btnClickPackageId: null
      }))
    }
  }


  return (
    <>
      {addonInvoicePreviewData?.isOpenModal && (
        <AddonPreviewModal accountType={"marketPlaceAccount"} />
      )}
      
      {razorpayModalData?.isRazorPayModal && (
        <RazorpayModal
          navigationUrl={afterPaymentSuccessNavigationUrl}
        />
      )}
      <div className='without-datepicker-breadcrumb'>
        <Breadcrumb />
      </div>

      <section className="section dashboard py-2">
        {modalOpenLoading && (
          <Loading
            image="https://upload.wikimedia.org/wikipedia/commons/a/a9/Amazon_logo.svg"
            text="Connecting your Amazon account..."
          />
        )}
        <div className="mb-4 marketplace-badges graph-section">
          <h5 className='kpi-heading'>{t("marketplace.addAccount")}</h5>
          {marketplaceData.map((marketplaceData, idx) => (
            <span
              key={idx}
              className="badge custom-text-dark border badge-marketplace"
              onClick={() => handleBadgeClick(marketplaceData.name)}
            >
              <div className="badge-logo"
              >
                <img
                  src={marketplaceData.logo_url}
                  alt={marketplaceData.name}
                  style={{
                    width: '86%',
                    objectFit: 'contain',
                    height: "30px"
                  }}
                />
              </div>
            </span>
          ))}
        </div>
        {/* {loadingState.} */}
        <div className='graph-section'>
          <DataTableLayout traceBtnClick={traceBtnClick} onPayAgain={handlePayAgain} tableId={tableId} ajaxUrl={ajaxUrl} columns={columns} tableIdParams={tableIdParams} />
        </div>
        <ConfirmModal
          show={modalOpen}
          title="Connect Your Account"
          message={`To proceed, please connect your account.
           We ensure secure access and use your data responsibly to support your growth.`}
          onConfirm={handleConfirm}
          onCancel={handleCancel}
        />
      </section>
    </>
  );
};

export default MarketPlaceAccounts;
